import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {ItemEvent} from "../../../ItemEvent";
declare const Yiit;

@Component({
  selector: 'info-window-component',
  templateUrl: './info-window-afs.component.html',
  styleUrls: ['./info-window-afs.component.scss']
})
export class InfoWindowAfsComponent implements OnInit {

  @Input() item;

  public isInitInfoWindow = false;
  public isInfoVisible = true;
  public Yiit = Yiit;

  constructor() {}

  ngOnInit(): void {
    this.isInitInfoWindow = false;
    let e = new ItemEvent(this.item, 'infoAfsInitialized');
    e.childComponent = this;
    this.item.emitter.next(e);
  }

  changeVisibility(value){
    let e = new ItemEvent(this.item, 'infoVisibilityChanged');
    e.infoWindowVisibility = value.target.checked;
    this.item.emitter.next(e);
  }



}
